<template>
  <div class="mall-booking-step">
    <div class="mall-booking-step__icon">
      <img :src="icon" alt="" />
    </div>
    <div class="mall-booking-step__text">
      <span class="mall-booking-step__title">{{ title }}</span>
      <span class="mall-booking-step__desc">
        <span v-for="line in descriptionLines" :key="line" class="mall-booking-step__line">{{ line }}</span>
      </span>
    </div>
  </div>
</template>

<script>
// 진료예약 안내 단계 (아이콘 + 제목 + 설명)
export default {
  name: 'MallBookingStep',
  props: {
    icon: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    // 줄 단위 설명
    descriptionLines: {
      type: Array,
      default: () => [],
    },
  },
}
</script>

<style scoped>
/* 진료예약 화면 캡처(Figma 197:10243) 기준 크기 */
.mall-booking-step {
  display: flex;
  padding: 17px 0 16px 4px;
  align-items: flex-start;
  gap: 31px;
  border-top: 1px solid #ECECEC;
}

.mall-booking-step__icon {
  display: flex;
  flex-shrink: 0;
  width: 52px;
  height: 52px;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background: #DBEDFF;
}

.mall-booking-step__icon img {
  display: block;
}

.mall-booking-step__text {
  display: flex;
  min-width: 0;
  flex-direction: column;
  font-family: Pretendard;
}

.mall-booking-step__title {
  color: #222222;
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-bold);
  line-height: 26px;
}

.mall-booking-step__desc {
  color: #444444;
  font-size: 15px;
  font-weight: 400;
  line-height: 24px;
}

.mall-booking-step__line {
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/new/molecules/MallBookingStep.vue